module.exports = __webpack_public_path__ + "img/tree-08-b-trunk.b7569595.png";